import React, {useContext} from "react";
import ActionsContext from "common/ActionsContext";
import BtaTrafficHelpModal from "./Help";
import BtaTrafficReport from "./Report";
import { Header } from "common/Header";

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <a
        data-loading-effect="pulse"
        data-toggle="cardloading"
        title="Help"
        onClick={() => actions.send("open-help")}
      >
        <i className="material-icons">help_outline</i>
      </a>
      <a
        onClick={() => actions.send("do-load")}
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">
          refresh
        </i>
      </a>
    </ul>
  );
};

const BtaTraffic = () => {
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
     <div className="card">
        <Header
          title="Optimization/Shaping Throughput"
          contextMenu={<ContextMenu />}
        />
        <div className="body flex-panel-row">
          <BtaTrafficReport />
        </div>
      </div>
      <BtaTrafficHelpModal />
    </div>
  );
};

export default BtaTraffic;